import React from 'react'
import { EditorialType, FundingType } from '../../../lib'
import {
    StyledEditorialLabel,
    StyledEditorialLabelText,
} from './EditorialLabel.styled'

export interface EditorialLabelProps {
    className?: string
    type: EditorialType | FundingType
    cardHasBackground?: boolean
    isLarge?: boolean
}

export const EditorialLabel: React.FC<EditorialLabelProps> = ({
    className,
    type,
}) => {
    return (
        <StyledEditorialLabel className={className}>
            <StyledEditorialLabelText type={type}>
                {type}
            </StyledEditorialLabelText>
        </StyledEditorialLabel>
    )
}
EditorialLabel.displayName = 'EditorialLabel'
